/* eslint-disable react/no-multi-comp */
/* eslint jsx-a11y/no-static-element-interactions: 0 */
import React, { Component } from 'react';
import { withEditorState } from './EditorStateContext';
import { internalToAbsolute } from '../utilities/linkUtilities';

class EditLink extends Component {
    selectLink = (e) => {
        const {
            selectLink,
            hideEditLink,
            entityKey,
            decoratedText,
        } = this.props;
        e.preventDefault();
        e.stopPropagation();
        selectLink(entityKey, decoratedText.length);
        hideEditLink();
    };

    render() {
        const { url } = this.props;

        return (
            <div readOnly contentEditable={false} className="link-edit-button-container">
                <div onClick={this.selectLink} className="link-edit-button-inner-container">
                    <span className="link-edit-display">{url}</span>
                    <span className="link-edit-button">Edit</span>
                </div>
            </div>
        );
    }
}

class Link extends Component {
    state = { showEditLink: true };

    render() {
        const {
            entityKey,
            contentState,
            readOnly,
            children,
        } = this.props;
        const { showEditLink } = this.state;
        const { fromDialog } = contentState.getEntity(entityKey).getData();
        let { url } = contentState.getEntity(entityKey).getData();
        url = internalToAbsolute(url);
        const urlTarget = url.includes(window.location.hostname) ? '' : '_blank';
        const customClass = fromDialog ? 'link-inline-reference' : '';
        if (url.includes('mailto:')) {
            url = url.replace('http://', '');
        }

        return (
            <span className="link-edit">
                <a
                    href={url}
                    className={customClass}
                    target={urlTarget}
                    rel="noopener noreferrer"
                    onMouseEnter={() => this.setState({ showEditLink: true })}
                >
                    {children}
                </a>
                {
                    !readOnly
                    && showEditLink
                    && <EditLink {...this.props} url={url} hideEditLink={() => this.setState({ showEditLink: false })} />
                }
            </span>
        );
    }
}

export default withEditorState(Link);
